import { render, staticRenderFns } from "./MobileHomeSection.vue?vue&type=template&id=3545456e&scoped=true"
import script from "./MobileHomeSection.vue?vue&type=script&lang=js"
export * from "./MobileHomeSection.vue?vue&type=script&lang=js"
import style0 from "./MobileHomeSection.vue?vue&type=style&index=0&id=3545456e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3545456e",
  null
  
)

export default component.exports